import IndustryParentAddEdit from "./AddEdit";

const IndustryParentAdd = () => {
    return (
        <IndustryParentAddEdit />
    );
};

export default IndustryParentAdd;
